/** Position for a new item placed after all the others. */
export function nextPosition(items: readonly { position: number }[]): number {
  return items.reduce((max, item) => Math.max(max, item.position), 0) + 1;
}
